import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography, Box } from '@mui/material';
import { MuiOtpInput } from 'mui-one-time-password-input'
import { NavigateFunction, useLocation, useNavigate } from 'react-router-dom';

// COMPONENT 👇
import * as styles from '.././styles/login.style'
import { RouteImage } from '../../../assets/routeImage';
import { ButtonCustom } from '../../../component/mui-custom/MuiCustom';
import { swalError } from '../../../component/notification/swal';
import Loading from '../../../component/loading/Loading';

// API
import { Authentication, validateOtpType } from '../../../api/auth/Authentication.api';
import { ResourcePathApi } from '../../../constants/resource.pathapi';


type otpType = {
    email: string;
    otp: string;
    otpRefer: string;
}

const OtpConfirm: React.FC = () => {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const location = useLocation();

    const email: string = location.state?.email
    const ref: string = location.state?.ref
    const [pathUrl, setPathUrl] = useState<any>(null);

    const [formState, setFormState] = useState<otpType>({
        email: email,
        otp: "",
        otpRefer: ref
    });
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const handleChangeOtp = (otp: string) => setFormState({ ...formState, ['otp']: otp })
    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setIsLoading(true)
        let condition: validateOtpType = {
            email: formState.email,
            otp: formState.otp,
            ref: formState.otpRefer
        }
        await Authentication.validateOtp(condition)
            .then(res => {
                if (res.status === 200) {
                    setIsLoading(false)
                    const accessToken = res.data?.result?.accessToken
                    accessToken && navigate('/reset-password', { state: { isAccept: true, token: accessToken } })
                } else {
                    setIsLoading(false)
                }
            })
            .catch(error => {
                setIsLoading(false)
                swalError(error?.response?.data?.description)
            })

    }

    useEffect(() => {
        if (!location.state || !location.state.email) {
            navigate('/forgot-password');
        }
    }, [location]);

    useEffect(() => {
        const fetchPath = async () => {
            const path = await ResourcePathApi();
            setPathUrl(path);
        }
        fetchPath();
    }, [])

    return (
        <styles.Container
        sx={{
            background: pathUrl && `url(${pathUrl.REACT_APP_BASE_API}/login-background) no-repeat`,
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}
        >
            {isLoading && <Loading />}
            <styles.FormAuthentication className='w-full' onSubmit={handleSubmit}>
                <styles.MainBox>
                    <styles.LoginBox
                        style={{ minHeight: "694px" }}
                        className='border-[1px] border-light'
                        initial={{ x: 200 }}
                        animate={{ x: 0 }}
                        transition={{ type: "spring", stiffness: 100, ease: "backInOut", bounce: 0.25 }}
                    >
                        <div className='flex justify-center items-center'>
                            <img src={RouteImage.login_logo} alt='logo' />
                        </div>
                        <div className='mt-[36px]'>
                            <Typography variant='h4' component="h1">{t("ระบบสารสนเทศเพื่อการติดตามและประเมินผลโครงการ")}</Typography>
                            <Typography variant='h4' component="h1" >
                                {t(" (E-Monitoring and Evaluation)")}
                            </Typography>
                        </div>

                        <Box className="mt-9 flex justify-center items-center relative gap-x-3">
                            <span className='flex-1 h-[1px] bg-base_secondary'></span>
                            <span>
                                <Typography className='text-base_secondary' variant='h6'>
                                    {t("AUTH.CONFIRM_OTP")}
                                </Typography>
                            </span>
                            <span className='flex-1 h-[1px] bg-base_secondary'></span>
                        </Box>
                        <Box className="mt-9">
                            <div className='w-full flex justify-center items-center content-email'>
                                <MuiOtpInput
                                    sx={{
                                        padding: "0 1.3rem",
                                        gap: "0.5rem",
                                        '.MuiOutlinedInput-input': {
                                            padding: '1.4rem 0',

                                        }
                                    }}
                                    className='w-[26rem] p-0'
                                    autoFocus
                                    inputMode='numeric'
                                    value={formState.otp}
                                    validateChar={(val: string) => !isNaN(Number(val))}
                                    onChange={handleChangeOtp}
                                    length={6} />
                            </div>
                        </Box>
                        <Box className="mt-2">
                            <Typography className='text-base_secondary'>{"ระบบจะทำการส่งลิงก์การตั้งค่ารหัสผ่านใหม่ให้ท่าน"}</Typography>
                        </Box>
                        <Box className='w-full mt-[36px]'>
                            <ButtonCustom disabled={formState.otp.length !== 6} type='submit' variant='contained' sx={{ height: "48px" }} fullWidth>
                                {t("BUTTON.SUBMIT")}
                            </ButtonCustom>
                        </Box>
                    </styles.LoginBox>
                </styles.MainBox>
            </styles.FormAuthentication>
        </styles.Container>
    )
}

export default OtpConfirm
